class RecorderService {
  constructor() {
    this.mediaRecorder = null
    this.audioChunks = []
  }

  // 開始錄音
  async startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      this.mediaRecorder = new MediaRecorder(stream)
      this.audioChunks = []

      this.mediaRecorder.ondataavailable = (event) => {
        this.audioChunks.push(event.data)
      }

      this.mediaRecorder.start()
    } catch (error) {
      console.error('Error starting recording:', error)
      throw error
    }
  }

  // 停止錄音
  stopRecording() {
    return new Promise((resolve) => {
      this.mediaRecorder.onstop = () => {
        const audioBlob = new Blob(this.audioChunks, { type: 'audio/mp3' })
        resolve(audioBlob)
      }
      this.mediaRecorder.stop()
      this.mediaRecorder.stream.getTracks().forEach(track => track.stop())
    })
  }

  // 檢查是否正在錄音
  isRecording() {
    return this.mediaRecorder && this.mediaRecorder.state === 'recording'
  }
}

export default new RecorderService() 